module.exports = __webpack_public_path__ + "static/media/word.8af7b037.svg";